import RequesterV1 from "@/components/api/v1/requester.js";

const rootPath = "agro_exporter/finances/container_outcomes";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${rootPath}/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `${rootPath}/show_container/${agro_exporter_id}/fetch_container/${container_id}`
    );
  },
  fetchCurrencies(agro_exporter_id) {
    return RequesterV1.get(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/fetch_currencies`
    );
  },
  fetchExporterProcessCropPackages(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/fetch_exporter_process_crop_packages/${agro_exporter_process_id}`
    );
  },
  fetchContainerProviders(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/fetch_container_providers/${container_id}`
    );
  },
  fetchInvoiceIssuers(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/fetch_invoice_issuers/${container_id}`
    );
  },
  fetchOrgInvoice(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/fetch_org_invoice/${org_invoice_id}`
    );
  },
  create(agro_exporter_id, org_invoice_params) {
    return RequesterV1.post(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/create`,
      { org_invoice: org_invoice_params }
    );
  },
  update(agro_exporter_id, org_invoice_id, org_invoice_params) {
    return RequesterV1.post(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/update/${org_invoice_id}`,
      { org_invoice: org_invoice_params }
    );
  },
  destroy(agro_exporter_id, org_invoice_id) {
    return RequesterV1.delete(
      `${rootPath}/manage_org_invoice/${agro_exporter_id}/destroy/${org_invoice_id}`
    );
  }
};
